function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Microphone"
}, React.createElement("path", {
  className: "cls-1",
  d: "M13.125,6.126A.875.875,0,0,0,12.25,7,5.25,5.25,0,0,1,1.75,7,.875.875,0,0,0,0,7,7,7,0,0,0,14,7,.875.875,0,0,0,13.125,6.126Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M7,10.5A3.51,3.51,0,0,0,10.5,7V3.5a3.5,3.5,0,0,0-7,0V7A3.51,3.51,0,0,0,7,10.5Z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/microphone.a54b2ff8.svg";
export { SvgComponent as ReactComponent };